module.exports = __webpack_public_path__ + "media/images/flags/1x1/khm-e191502b8a7d416e23439b194432f892.svg";